const bankImportBalanceStatusApi = {
  csvBalances: (lines: any[]) => {
    if (!lines.length || lines.some((line) => !Number.isFinite(line.balance))) return {};
    const ordered = lines.every((line, index) => !index || lines[index - 1].date <= line.date) ? lines : [...lines].reverse();
    if (ordered.some((line, index) => index && (ordered[index - 1].date > line.date || Math.abs(ordered[index - 1].balance + line.amount - line.balance) >= .005))) return {};
    return { openingBalance: ordered[0].balance - ordered[0].amount, closingBalance: ordered[ordered.length - 1].balance };
  },
  missing: (statement: any) => {
    const raw = statement?._backend || statement || {};
    return Boolean(raw.periodImport && ['openingBalance', 'closingBalance'].some((key) => raw[key] == null || raw[key] === '' || !Number.isFinite(Number(raw[key]))));
  },
  partial: (statement: any) => {
    const raw = statement?._backend || statement || {};
    const end = String(raw.periodTo || '');
    if (!/^\d{4}-\d{2}-\d{2}$/.test(end)) return Boolean(raw.periodImport);
    return Boolean(raw.periodImport && end !== new Date(Date.UTC(Number(end.slice(0, 4)), Number(end.slice(5, 7)), 0)).toISOString().slice(0, 10));
  },
};
window.PlummeBankImportBalanceStatus = bankImportBalanceStatusApi;
